import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { markSiteUnsynced } from "../../../utils/syncStore";
import { DiceAlertsTab } from "../DiceAlertsTab";
import { IgnoreZonesBreadCrumbs } from "../../EditIgnoreZones/IgnoreZonesBreadCrumbs";
import { createIgnoreZonesLinksArray } from "../../EditIgnoreZones/EditIgnoreZonesUtils/createIgnoreZonesLinksArray";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { getNumbersAfterEditCamera, getNumbersAfterSites } from "../EditCamera";
import { AlertSettingsTab } from "../AlertSettingsTab";
import ErrorBoundary from "../../../../ErrorBoundary";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";

export const handleSubmitNewDiceAlert = async (
  cameraGeneralInfo: any,
  diceAlerts: any,
  postObject: any,
  navigate: any,
  setBackdropLoadingScreenOn: any,
  setCameraGeneralInfo: any,
  setCameraGeneralInfoBackup: any,
  setGeneralInfoChangesMade: any,
  setPatchObject: any,
  setDiceAlerts: any,
  setActiveTab: any,
  setAddDiceAlertDialogOpen: any,
  cameraGeneralInfoBackup: any,
  setIgnoreZonesBreadCrumbs: any,
  handleSitesBreadcrumbClick: any,
  handleSingularSiteBreadcrumbClick: any,
  setSendingDiceTest: Dispatcher<boolean>,
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>,
  setDiceTestFailDialogOpen: Dispatcher<boolean>,
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>,
  sureviewAlerts: any,
  setAddSureviewAlertDialogOpen: any,
  cameraWebhookData: any,
  setAddStreamWebhookDialogOpen: any,
  setEditStreamWebhookDialogOpen: any,
  sentinelAlerts: any,
  setAddSentinelAlertDialogOpen: any,
  boldAlerts: any,
  setAddBoldAlertDialogOpen: Dispatcher<boolean>,
  patriotAlerts: any,
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>,
  softguardAlerts: any,
  setAddSoftguardAlertDialogOpen: Dispatcher<boolean>,
  diceAlertsOnCamera: any,
  sureViewAlertsOnCamera: any,
  siteInfo: any,
  webhooksAlertsOnCamera: any,
  sentinelAlertsOnCamera: any,
  boldAlertsOnCamera: any,
  patriotAlertsOnCamera: any,
  softguardAlertsOnCamera: any,
  evalinkAlertsOnCamera: boolean
) => {
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    handleSubmitNewDiceAlert(
      cameraGeneralInfo,
      diceAlerts,
      postObject,
      navigate,
      setBackdropLoadingScreenOn,
      setCameraGeneralInfo,
      setCameraGeneralInfoBackup,
      setGeneralInfoChangesMade,
      setPatchObject,
      setDiceAlerts,
      setActiveTab,
      setAddDiceAlertDialogOpen,
      cameraGeneralInfoBackup,
      setIgnoreZonesBreadCrumbs,
      handleSitesBreadcrumbClick,
      handleSingularSiteBreadcrumbClick,
      setSendingDiceTest,
      setDiceTestSuccessDialogOpen,
      setDiceTestFailDialogOpen,
      setDeleteDiceAlertDialogOpen,
      sureviewAlerts,
      setAddSureviewAlertDialogOpen,
      cameraWebhookData,
      setAddStreamWebhookDialogOpen,
      setEditStreamWebhookDialogOpen,
      sentinelAlerts,
      setAddSentinelAlertDialogOpen,
      boldAlerts,
      setAddBoldAlertDialogOpen,
      patriotAlerts,
      setAddPatriotAlertDialogOpen,
      softguardAlerts,
      setAddSoftguardAlertDialogOpen,
      diceAlertsOnCamera,
      sureViewAlertsOnCamera,
      siteInfo,
      webhooksAlertsOnCamera,
      sentinelAlertsOnCamera,
      boldAlertsOnCamera,
      patriotAlertsOnCamera,
      softguardAlertsOnCamera,
      evalinkAlertsOnCamera
    );
  };

  let postPatchObjectFail = false;
  let getSiteCamerasFail = false;

  const { setCameraStreamsPatchObject, setCameraStreamsObject } =
    useEditCameraStore.getState();

  await AxiosUI.patch(
    `/camera/${getNumbersAfterEditCamera(location.href)}/general_info/`,
    {
      streams: postObject,
    }
  ).then(
    (response: AxiosResponse) => {
      postPatchObjectFail = false;
      markSiteUnsynced();
      setCameraGeneralInfo(response.data);
      setCameraGeneralInfoBackup(response.data);
      setCameraStreamsPatchObject(response.data.streams);
      setCameraStreamsObject(response.data.streams);
      const pushedArray: any[] = [];
      response.data.streams[0].dice_alerts.forEach((alertObject: any) => {
        pushedArray.push(alertObject);
      });
      setDiceAlerts(pushedArray);
      setGeneralInfoChangesMade(false);
      setPatchObject({});
      setActiveTab(
        <ErrorBoundary>
          <AlertSettingsTab
            diceAlerts={pushedArray}
            setAddDiceAlertDialogOpen={setAddDiceAlertDialogOpen}
            setSendingDiceTest={setSendingDiceTest}
            setDiceTestSuccessDialogOpen={setDiceTestSuccessDialogOpen}
            setDiceTestFailDialogOpen={setDiceTestFailDialogOpen}
            setDeleteDiceAlertDialogOpen={setDeleteDiceAlertDialogOpen}
            sureviewAlerts={sureviewAlerts}
            setAddSureviewAlertDialogOpen={setAddSureviewAlertDialogOpen}
            setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
            setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
            sentinelAlerts={sentinelAlerts}
            setAddSentinelAlertDialogOpen={setAddSentinelAlertDialogOpen}
            boldAlerts={boldAlerts}
            setAddBoldAlertDialogOpen={setAddBoldAlertDialogOpen}
            patriotAlerts={patriotAlerts}
            setAddPatriotAlertDialogOpen={setAddPatriotAlertDialogOpen}
            softguardAlerts={softguardAlerts}
            setAddSoftguardAlertDialogOpen={setAddSoftguardAlertDialogOpen}
            diceAlertsOnCamera={diceAlertsOnCamera}
            sureViewAlertsOnCamera={sureViewAlertsOnCamera}
            siteInfo={siteInfo}
            webhooksAlertsOnCamera={webhooksAlertsOnCamera}
            sentinelAlertsOnCamera={sentinelAlertsOnCamera}
            boldAlertsOnCamera={boldAlertsOnCamera}
            patriotAlertsOnCamera={patriotAlertsOnCamera}
            softguardAlertsOnCamera={softguardAlertsOnCamera}
            evalinkAlertsOnCamera={evalinkAlertsOnCamera}
            navigate={navigate}
          />
        </ErrorBoundary>
      );
      setBackdropLoadingScreenOn(false);
    },
    (reason: AxiosError) => {
      postPatchObjectFail = true;
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setCameraGeneralInfo(cameraGeneralInfoBackup);
        setPatchObject({
          camera_name: cameraGeneralInfoBackup.camera_name,
          streams: cameraGeneralInfoBackup.streams,
        });
        setBackdropLoadingScreenOn(false);
      });
    }
  );
  !postPatchObjectFail &&
    (await AxiosUI.get(
      `camera/site/?customer__id=${getNumbersAfterSites(location.href)}`
    ).then(
      (response: AxiosResponse) => {
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          getSiteCamerasFail = true;
        });
      }
    ));
  !postPatchObjectFail &&
    !getSiteCamerasFail &&
    (await AxiosUI.get(
      `customer/${getNumbersAfterSites(location.href)}/about/`
    ).then(
      (response: AxiosResponse) => {
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(
          <IgnoreZonesBreadCrumbs
            linksArray={createIgnoreZonesLinksArray(response.data.breadcrumbs)}
            handleSitesBreadcrumbClick={handleSitesBreadcrumbClick}
            handleSingularSiteBreadcrumbClick={
              handleSingularSiteBreadcrumbClick
            }
            styling="absolute top-[10px] left-[30px]"
          />
        );
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          setBackdropLoadingScreenOn(false);
        });
      }
    ));
};
